import React from 'react';
import { cn } from '../../lib/utils';
import { icons } from '../ui/Icons';

export interface EmptyStateProps {
  icon?: keyof typeof icons;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({ icon = 'Inbox', title, description, action, className }: EmptyStateProps) {
  const Icon = icons[icon] || icons.Inbox;

  return (
    <div className={cn('flex min-h-[220px] flex-col items-center justify-center px-6 py-10 text-center', className)}>
      <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-neutral-100 text-neutral-500 dark:bg-neutral-800 dark:text-neutral-400">
        <Icon className="h-5 w-5" aria-hidden="true" />
      </div>
      <h3 className="mt-4 text-h3 font-semibold text-neutral-900 dark:text-neutral-100">{title}</h3>
      {description && <p className="mt-1 max-w-md text-body text-neutral-600 dark:text-neutral-300">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
